export default __webpack_public_path__ + "static/media/logoMIFU.452c7f55.png";